import React, { useEffect, useState } from 'react'
import './categories.styles.scss';
import { sanitize } from '@/utils/sanitize';
import { useSelector } from 'react-redux';

/**
 * 
 * @param {object} param0
 * @param {string} param0.type
 * @param {function} param0.saveData
 * @param {object} param0.formData
 * @param {array} param0.categories
 * @param {boolean} param0.disabled
 * @returns 
    * schema:
    * opt_cat
 */
const ManageContentCategories = ({ 
    type, 
    saveData, 
    formData, 
    categories, 
    disabled 
}) => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ textCat, setTextCat ] = useState('');
    const [ selectCat, setSelectCat ] = useState('');

    useEffect(() => {
        // console.log(categories);
    }, [categories])

    useEffect(() => {
        if (!formData) {return;}
        if (formData.opt_cat) {
            setSelectCat(formData.opt_cat);
        }
    }, [formData])

    function chooseCategory(cat, format) {
        if (format === 'new') {
            setSelectCat('')
            setTextCat(cat);
        } else {
            setTextCat('')
            setSelectCat(cat);
        }
        saveData('opt_cat', cat)
    }


    return (
        <div className={`manage-content-categories g-list-item form-section ${disabled} ${screenSize}`}>
            <h3>Category</h3>
            <hr />
            <div className="categories-content">
                <div className='field small'>
                    <label>Assign a Category</label>
                    <input type='text' id='category-input' value={textCat} placeholder='Category Name' onChange={(e) => chooseCategory(sanitize(e.target.value), 'new')} />
                </div>
                <div className='field small'>
                    <label>OR Choose an Existing Category</label>
                    <select id='category-select' value={selectCat} onChange={(e) => chooseCategory(e.target.value, 'existing')} required>
                        <option value='' >Choose a Category...</option>
                        {
                            (categories.length > 0) &&
                            categories.map(c => (
                                <option key={c} value={c}>{c}</option>
                            ))
                        }
                    </select>
                </div>
            </div>
            <div className="g-space-1"></div>
        </div>
    )
}

export default ManageContentCategories